import { Injectable } from "@angular/core";
import { PHBHPApiService } from "ph-bhp-feature-packages/ph-bhp-layout-package/lib/ph-bhp-api.service";
import { Observable } from "rxjs/Rx";
import { ProfessionalCategory } from "../models/professional-category";
import { ProfessionalSubCategory } from "../models/professional-sub-category";
import { AppConfig } from "../../../../../../Mobile/Observe/src/app/app.config";
import { ProfessionalSubCategoryDTO } from '../models/professional-sub-category-dto';

@Injectable({
  providedIn: "root",
})
export class CatalogMasterService {
  constructor(private service: PHBHPApiService, private appConfig: AppConfig) {}

  createProfessionalCategory(data) {
    return this.service.postApi(
      "ProfessionalCategories/CreateProfessionalCategory",
      data,
      true
    );
  }

  createSubCategory(data) {
    return this.service.postApi(
      "ProfessionalSubCategories/CreateProfessionalSubCategory",
      data,
      true
    );
  }

  deleteProfessionalCategory(id) {
    return this.service.deleteApi(
      "ProfessionalCategories/deleteProfessionalCategory/" + id,
      true
    );
  }

  deleteSubCategory(id) {
    return this.service.deleteApi(
      "ProfessionalSubCategories/DeleteProfessionalSubCategory/" + id,
      true
    );
  }

  getDepartmentList() {
    return this.service.getApi("Departments/GetDepartments", true);
  }

  getDepartmentById(id) {
    return this.service.getApi("Departments/GetDepartmentById/" + id, true);
  }

  getProfessionalCategories(): Observable<Array<ProfessionalCategory>> {
    return this.service.getApi(
      "ProfessionalCategories/GetProfessionalCategories",
      true
    );
  }

  getProfessionalSubCategories(): Observable<Array<ProfessionalSubCategory>> {
    return this.service.getApi(
      "ProfessionalSubCategories/GetProfessionalSubCategories/",
      true
    );
  }

  getProfessionalSubCategoriesByCountry(
    countryID
  ): Observable<Array<ProfessionalSubCategoryDTO>> {
    return this.service.getApi(
      "ProfessionalSubCategories/GetProfessionalSubCategoriesByCountry/" +
        countryID,
      true
    );
  }

  getProfessionalSubCategoriesByCategoryId(
    categoryId,
    countryID,
  ): Observable<Array<ProfessionalSubCategoryDTO>> {
    return this.service.getApi(
      "ProfessionalSubCategories/GetProfessionalSubCategoryByCatId/" +
        categoryId + "/" + countryID,
      true
    );
  }

  updateProfessionalCategory(id, data) {
    return this.service.putApi(
      "ProfessionalCategories/UpdateProfessionalCategory/" + id,
      data,
      true
    );
  }

  updateSubCategory(id, data) {
    return this.service.putApi(
      "ProfessionalSubCategories/UpdateProfessionalSubCategory/" + id,
      data,
      true
    );
  }

  updateSubCategoryTranslation(id, countryId, data) {
    return this.service.putApi(
      `ProfessionalSubCategories/UpdateSubCategoryTranslation/${id}/${countryId}`,
      data,
      true
    );
  }

}
